import { render } from "./UpdateProfile.vue?vue&type=template&id=5a7b48be"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=5a7b48be&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__